export default __webpack_public_path__ + "static/media/Hospital.0bbdd4d6.svg";